import React from "react";
// Cache buster
import CacheBuster from 'react-cache-buster';
import { version } from '../package.json';

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { Home } from "./pages/Home";
import { About } from "./pages/About";
import { Contact } from "./pages/Contact";
import { Dashboard } from "./pages/Dashboard";
import { Customercases } from "./pages/Customercases";
import { Services } from "./pages/Services";
import { Skills } from "./pages/Skills";
import { AuthProvider } from "./auth/AuthContext";
import { ProtectedRoute } from "./auth/ProtectedRoute";
import { CssBaseline, Container, CircularProgress, Grid } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./theme/theme";


// Cachebusting toggle - leaving here for easy disablement if production issues occours
const isCacheBustingEnabled = true;
const isCacheBustingVerbose = true;

function ShowCacheCheckingInfo(): JSX.Element {
  // eslint-disable-next-line no-console
  console.log('Checking for new version and refreshing cache if required');
  return (
    <>
      <CircularProgress /> 
      <span>Checking for new version and refreshing cache if required</span>
    </>
  );
}


export default function App() {
  return (
    <CacheBuster
      currentVersion={version}
      isEnabled={isCacheBustingEnabled} //If false, the library is disabled.
      isVerboseMode={isCacheBustingVerbose} //If true, the library writes verbose logs to console.
      loadingComponent={<ShowCacheCheckingInfo />} //If not pass, nothing appears at the time of new version check.
      reloadOnDowngrade={true}
      /*
              metaFileDirectory={'.'} //If public assets are hosted somewhere other than root on your server.
      */
    >
      <ThemeProvider theme={theme}>
        <AuthProvider>
          <Router>
            <CssBaseline />
            {/* <Container maxWidth={false} diasbleGutters sx={{ py: 4, paddingTop: 0 }}> */}
            <Grid container spacing={2} columns={12} >
              <Grid size={{ xs:12, sm:12, md:12, lg:12, xl:12 }} >
                <Header />
              </Grid>
              {/* <Container disableGutters sx={{ margin: "0px auto" }}> */}
              <Grid size={{ xs:12, sm:12, md:12, lg:12, xl:12 }} sx={{ marginLeft: "16px", marginRight: "16px" }}>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route
                    path="/dashboard"
                    element={<ProtectedRoute><Dashboard /></ProtectedRoute>}
                  />
                  <Route path="/customercases" element={<Customercases />} />
                  <Route path="/skills" element={<Skills />} />
                  <Route path="/services" element={<Services />} />
                </Routes>
              </Grid>
              <Grid size={{ xs:12, sm:12, md:12, lg:12, xl:12 }} >  
                <Footer />
              </Grid>
            </Grid>
          </Router>
        </AuthProvider>
      </ThemeProvider>
    </CacheBuster>
  );
}